import React from 'react';
import styled from 'styled-components';

export interface VideoProps {
  poster?: string;
  webm: string;
  mpeg: string;
  width?: number;
  height?: number;
  className?: string;
}

const VideoWrapper = styled.div`
  overflow: hidden;
`;

// Хак для Safari — React режет muted
const Video: React.FC<VideoProps> = (props) => {
  const {
    poster,
    webm,
    mpeg,
    width,
    height,
    className
  } = props;
  
  return (
    <VideoWrapper className={className} dangerouslySetInnerHTML={{ __html: `
      <video
        style="object-fit: cover; width: 100%; height: 100%;"
        poster=${poster}
        width=${width}
        height=${height}
        autoplay
        loop
        muted
        playsinline
      >
        <source src="${webm}" type="video/webm" />
        <source src="${mpeg}" type="video/mp4" />
      </video>
    `}}>
    </VideoWrapper>
  );
}

export { Video };
